module.exports = Waypoint;


//////////////////
// WEBPACK FOOTER
// external "Waypoint"
// module id = 82
// module chunks = 0